export class ModalLeftNavItem {
  key: string;
  visible: boolean = true;
  disabled: boolean = false;
  label: string;
  icon: string = null;
  count: number = null;
  issueCount: number = null;
  order: number = 9999;
  selected: boolean = false;
}
